import React from "react";
import styled from "@emotion/styled";
import { useParams } from "react-router-dom";
import { Zap } from "react-feather";
import { Home as HomeIcon, Language as MuiLanguageIcon } from "@mui/icons-material";

import useZone from "../../hooks/user/useZone";
import useAuth from "../../hooks/useAuth";

// Sidebar icons
import { ReactComponent as SslSvg } from "../../vendor/sidebar/ssl.svg";
import { ReactComponent as FwSvg } from "../../vendor/sidebar/firewall.svg";
import { ReactComponent as RlSvg } from "../../vendor/sidebar/ratelimit.svg";
import { ReactComponent as AppsSvg } from "../../vendor/application.svg";
import { ReactComponent as LLMSvg } from "../../vendor/llm-icon.svg";
import { ReactComponent as Analytics } from "../../vendor/sidebar/analytics.svg";

const LanguageIcon = styled(MuiLanguageIcon)`
  width: 24px;
  height: 24px;
`;
const ZapIcon = styled(Zap)`
  width: 24px;
  height: 24px;
`;
const SslIcon = styled(SslSvg)`
  width: 24px;
  height: 24px;
`;
const FwIcon = styled(FwSvg)`
  width: 24px;
  height: 24px;
`;
const RlIcon = styled(RlSvg)`
  width: 24px;
  height: 24px;
`;
const AppsIcon = styled(AppsSvg)`
  width: 24px;
  height: 24px;
`;
const LLMIcon = styled(LLMSvg)`
  width: 24px;
  height: 24px;
`;
const AnalyticsIcon = styled(Analytics)`
  width: 24px;
  height: 24px;
`;

function Items() {
  const { configZone } = useParams();
  const { isAuthenticated } = useAuth();
  const { zoneList, getZonesForItems } = useZone();

  React.useEffect(() => {
    if (isAuthenticated) {
      getZonesForItems();
    }
  }, [isAuthenticated, getZonesForItems]);
  React.useEffect(() => {
    if (isAuthenticated && zoneList === null) {
      getZonesForItems();
    }
  }, [isAuthenticated, zoneList, getZonesForItems]);

  const HomeNavbar = {
    href: "/home",
    icon: HomeIcon,
    title: "Home",
  };
  const ApplicationNavbar = {
    href: "/application",
    icon: AppsIcon,
    title: "Application",
  };
  const LLMNavbar = {
    href: "/llm",
    icon: LLMIcon,
    title: "LLM Zones",
  };
  const NavbarSection = [[HomeNavbar], [ApplicationNavbar], [LLMNavbar]];

  var LLMSidebarSectionOA = [];
  var LLMSidebarSectionNU = [];

  const ZoneSection = {
    href: "/llm/zones",
    icon: LanguageIcon,
    title: "LLM Zones",
  };

  if (zoneList === null || zoneList?.length === 0) {
    LLMSidebarSectionOA = [ZoneSection];
    LLMSidebarSectionNU = [ZoneSection];
  } else {
    const zoneUid = configZone ? configZone : "all";
    const LLMGuardSection = {
      href: "/llm",
      icon: ZapIcon,
      title: "LLM Guardrail",
      children: [
        {
          href: `/llm/${zoneUid}/guard/dashboard`,
          title: "Dashboard",
        },
        {
          href: zoneUid === "all" ? `/llm/${zoneList[0]?.id}/guard/config` : `/llm/${zoneUid}/guard/config`,
          title: "Configuration",
        },
      ],
    };
    const LLMSSLSection = {
      href: zoneUid === "all" ? `/llm/${zoneList[0]?.id}/ssl` : `/llm/${zoneUid}/ssl`,
      icon: SslIcon,
      title: "SSL",
    };
    const LLMFirewallSection = {
      href: zoneUid === "all" ? `/llm/${zoneList[0]?.id}/firewall` : `/llm/${zoneUid}/firewall`,
      icon: FwIcon,
      title: "LLM Firewall",
    };
    const LLMRateLimitSection = {
      href: zoneUid === "all" ? `/llm/${zoneList[0]?.id}/ratelimit` : `/llm/${zoneUid}/ratelimit`,
      icon: RlIcon,
      title: "Rate Limiting",
    };
    
    const AnalyticsSection = {
      href: "/llm",
      icon: AnalyticsIcon,
      title: "Analytics",
      children: [
        {
          href: "/llm/analytics/events",
          title: "LLM Event",
        },
        {
          href: "/llm/analytics/fw_events",
          title: "Firewall Event",
        },
        {
          href: "/llm/analytics/rl_events",
          title: "Rate Limit Event",
        },
      ],
    };
    LLMSidebarSectionOA = [ZoneSection, LLMGuardSection, LLMSSLSection, LLMFirewallSection, LLMRateLimitSection, AnalyticsSection];
    LLMSidebarSectionNU = [ZoneSection, LLMGuardSection, LLMSSLSection, LLMFirewallSection, LLMRateLimitSection, AnalyticsSection];
  }

  return {
    LLMSidebarSectionOA,
    LLMSidebarSectionNU,
    NavbarSection,
  };
}
export default Items;
